<template>
  <div>
    <a-modal
      v-bind="attrs"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      :centered="true"
      :title="getTitle()"
      okText="确认"
      @cancel="cancel"
      :zIndex="1008"
    >
      <a-form
        :model="states.formState"
        name="addWorkflow"
        ref="formRef"
        layout="vertical"
        :rules="rules"
        autocomplete="off"
        class="mt-20 mb-20"
        style="max-height: calc(100vh - 300px); overflow-y: auto"
      >
        <a-form-item label="" name="coverImage" v-if="store.newFolderData?.type != 'add'">
          <form-upload
            v-model:value="states.formState.coverImage"
            :types="['image/jpeg', 'image/png', 'image/jpg']"
            :maxSizeMB="2"
          >
            <div class="upload flex-col">
              <PlusOutlined class="fs-14 mr-4" />
              上传封面
            </div>
          </form-upload>
        </a-form-item>
        <a-form-item label="文件夹名称" name="name">
          <a-input v-model:value="states.formState.name" placeholder="请输入文件夹名称">
            <template #addonBefore>
              <div class="wd20 ht20 flex cursor-p" @click="visible = true">
                <component class="text-primary fs-16" :is="icons[states.formState.icon]" />
              </div>
            </template>
          </a-input>
        </a-form-item>
        <a-form-item label="描述" name="description">
          <a-input v-model:value="states.formState.description" placeholder="请输入描述内容" />
        </a-form-item>
        <a-form-item
          label="协作者"
          name="permissionList"
          v-if="
            (checkRunningEnvironment() == 'team' &&
              store.newFolderData?.parentId == '0' &&
              !store.newFolderData?.notPermissionList) ||
            (checkRunningEnvironment() == 'company' && !store.newFolderData?.notPermissionList)
          "
        >
          <teamWorkerInput
            v-model:value="states.formState.permissionList"
            placeholder="添加协作者"
          />
        </a-form-item>
      </a-form>
    </a-modal>
    <icon-modal
      v-model:open="visible"
      :init-value="states.formState.icon"
      @fnOk="
        (value) => {
          states.formState.icon = value
          visible = false
        }
      "
    />
  </div>
</template>

<script setup>
import {
  Modal as AModal,
  Form as AForm,
  Input as AInput,
  FormItem as AFormItem,
  message
} from 'ant-design-vue'
import { ref, reactive, useAttrs, watch, toRaw } from 'vue'
import IconModal from '@/components/iconModal'
import * as icons from '@ant-design/icons-vue'
import { cloneDeep } from 'lodash'
import formUpload from '@/components/formUpload'
import teamWorkerInput from '@/views/aiDAM/components/teamWorkerInput.vue'
import { PlusOutlined } from '@ant-design/icons-vue'
import { aigcStore } from '@/store/aigcStore'
import eventsBus from '@/utils/eventsBus'
import { createFolder, editFolder } from '@/service/api/aiDam'
import checkRunningEnvironment from '@/utils/runningEnvironment.js'

const emits = defineEmits(['asyncSuccess'])
const initForm = {
  coverImage: '',
  name: '',
  icon: 'FolderOutlined',
  description: '',
  permissionList: []
}
const rules = {
  name: [
    {
      required: true,
      message: '不能为空',
      trigger: 'change'
    },
    {
      max: 20,
      message: '长度不可超过20个字符',
      trigger: 'blur'
    }
  ],
  description: [
    {
      max: 40,
      message: '长度不可超过40个字符',
      trigger: 'blur'
    }
  ]
}
const store = aigcStore()
const attrs = useAttrs()
const states = reactive({
  formState: cloneDeep(initForm)
})
const confirmLoading = ref(false)
const visible = ref(false)
const formRef = ref()

const getTitle = () => {
  const str1 = store.newFolderData?.type != 'add' ? '编辑' : '新建'
  const str2 = store.newFolderData?.addChild ? '子文件夹' : '文件夹'
  return str1 + str2
}
const cancel = () => {
  states.formState = cloneDeep(initForm)
}
const handleOk = () => {
  formRef.value
    .validate()
    .then(() => {
      confirmLoading.value = true
      const obj = {
        ...toRaw(states.formState),
        parentId: store.newFolderData.parentId
      }
      if (store.newFolderData.teamId || store.newFolderData.ownerType) {
        obj['teamId'] = store.newFolderData.teamId
        obj['ownerType'] = store.newFolderData.ownerType
      }
      if (states.formState.id) {
        console.log(toRaw(states.formState))
        editFolder(obj, obj.id).then((res) => {
          if (res.data) {
            message.success('编辑成功')
            confirmLoading.value = false
            emits('asyncSuccess')
            eventsBus.emit('newFolder', obj)
          }
          confirmLoading.value = false
        })
      } else {
        createFolder(obj, obj.parentId).then((res) => {
          if (res.data) {
            message.success('新增成功')
            confirmLoading.value = false
            emits('asyncSuccess')
            eventsBus.emit('newFolder', null)
          }
          confirmLoading.value = false
        })
      }
    })
    .catch(() => {})
}
watch(
  () => attrs.open,
  (val) => {
    console.log(store.newFolderData?.type)
    confirmLoading.value = false
    if (val) {
      states.formState =
        store.newFolderData?.type != 'add' ? cloneDeep(store.newFolderData) : cloneDeep(initForm)
    }
  }
)
</script>

<style lang="less" scoped>
.upload {
  width: 100%;
  height: 80px;
  border: 2px dashed #ccc;
  border-radius: 6px;
  cursor: pointer;
  &:hover {
    border-color: @theme-color;
  }
}
:deep(.ant-upload-wrapper .ant-upload) {
  width: 100%;
}
</style>
